export default "__VITE_ASSET__DVF8AYqL__"